import { useQuery } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export interface PortInfoPort {
  PortName: string
  PortCode: string
  CountryName: string
  CountryCode: string
  ContinentName: string
  ContinentCode: string
}

export function useGetPortInfoPorts({ portName }: { portName?: string }) {
  const fetch = useFetch<PortInfoPort[]>()

  return useQuery({
    queryKey: ['/portinfo/ports', portName],
    queryFn: () => {
      const params = new URLSearchParams({ portName: portName ?? '' })
      return fetch(`${apiBase()}/portinfo/ports?${params.toString()}`)
    },
    enabled: !!portName && portName.length >= 3,
  })
}
